import { useQuery, useQueryClient } from "@tanstack/react-query";
import { LoginResults } from "./use-login";
import { queryClient } from "~/providers/query-provider";

export type AuthResults = LoginResults["role"];

export const getAuthQueryKey = () => ["getAuth"];

export const useAuthCache = () => {
	const queryClient = useQueryClient();

	return useQuery({
		queryKey: getAuthQueryKey(),
		queryFn: () =>
			queryClient.getQueryData<AuthResults>(getAuthQueryKey(), {
				exact: true,
			}) ?? null,
	});
};

export const getAuthCache = () => {
	return (
		queryClient.getQueryData<AuthResults>(getAuthQueryKey(), {
			exact: true,
		}) ?? null
	);
};
